<template>
	<!-- eslint-disable max-len -->
	<svg
		:class="$s.Star"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<path
			v-if="fill === 'full'"
			d="M8.00001 1.5L10.0433 5.00814C10.1846 5.25074 10.4214 5.42277 10.6958 5.48219L14.6636 6.34141L11.9586 9.36878C11.7716 9.57814 11.6811 9.85649 11.7094 10.1358L12.1184 14.175L8.40325 12.5379C8.14634 12.4246 7.85367 12.4246 7.59676 12.5379L3.88166 14.175L4.29062 10.1358C4.3189 9.85649 4.22846 9.57814 4.0414 9.36878L1.33637 6.34141L5.30423 5.48219C5.57862 5.42277 5.8154 5.25074 5.9567 5.00814L8.00001 1.5Z"
			:fill="color"
			:stroke="color"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			v-if="fill === 'empty'"
			d="M8.00001 1.5L10.0433 5.00814C10.1846 5.25074 10.4214 5.42277 10.6958 5.48219L14.6636 6.34141L11.9586 9.36878C11.7716 9.57814 11.6811 9.85649 11.7094 10.1358L12.1184 14.175L8.40325 12.5379C8.14634 12.4246 7.85367 12.4246 7.59676 12.5379L3.88166 14.175L4.29062 10.1358C4.3189 9.85649 4.22846 9.57814 4.0414 9.36878L1.33637 6.34141L5.30423 5.48219C5.57862 5.42277 5.8154 5.25074 5.9567 5.00814L8.00001 1.5Z"
			:stroke="color"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<template v-if="fill === 'half'">
			<path
				d="M8 1.5L10.0433 5.00814C10.1846 5.25074 10.4214 5.42277 10.6958 5.48219L14.6636 6.34141L11.9586 9.36878C11.7716 9.57814 11.6811 9.85648 11.7094 10.1358L12.1184 14.175L8.40325 12.5379C8.14634 12.4246 7.85367 12.4246 7.59676 12.5379L3.88166 14.175L4.29062 10.1358C4.3189 9.85649 4.22846 9.57814 4.0414 9.36878L1.33637 6.34141L5.30423 5.48219C5.57862 5.42277 5.8154 5.25074 5.9567 5.00814L8 1.5Z"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M4.74068 9.80798L4.44922 13.3867L7.81143 11.9653C7.85659 11.9462 7.90513 11.9364 7.95416 11.9364H7.96093L7.99999 2.91674L8 2.91518V2.5L7.90873 2.51626C7.85536 2.52576 7.80507 2.54799 7.7621 2.58105C7.734 2.60268 7.70948 2.6286 7.68944 2.65786L7.63343 2.73967L7.53284 2.91595L6.14573 5.48649C6.07563 5.6164 5.9517 5.7087 5.80714 5.73864L2.06665 6.51358L4.61907 9.43866C4.70778 9.54031 4.75163 9.67351 4.74068 9.80798Z"
				:fill="color"
			/>
		</template>
	</svg>
</template>

<script>
import cssValidator from '@square/maker/utils/css-validator';

/**
 * @inheritAttrs svg
 * @inheritListeners svg
 */
export default {
	inheritAttrs: false,

	props: {
		/**
		 * Determines the fill style of the star
		 */
		fill: {
			type: String,
			default: 'full',
			validator: (fill) => ['full', 'half', 'empty'].includes(fill),
		},
		/**
		 * Color of the star
		 */
		color: {
			type: String,
			default: '#ffbf00',
			validator: cssValidator('color'),
		},
	},
};
</script>

<style module="$s">
.Star {
	height: 32px;
}
</style>
